import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(theme => ({
	summaryPreviewCard: {
		backgroundColor: colors.purple[50],
		border: `1px solid ${colors.purple[200]}`,
		borderRadius: theme.spacing(0.5),
		padding: theme.spacing(1.5)
	},
	hidden: {
		display: "none"
	},
	summaryPreviewLabel: {
		color: colors.purple[600],
		fontWeight: 600,
		fontSize: 14,
		marginBottom: theme.spacing(0.5)
	},
	summaryPreviewText: {
		color: colors.purple[900],
		fontSize: 14,
		whiteSpace: "pre-line",
		overflow: "hidden"
	},
	sparklesIcon: {
		fontSize: 14,
		"& path": {
			fill: "currentColor"
		}
	}
}))

export default useStyles
